<template>
	<div class="bodybox">
		<!-- 顶部 -->
		<!-- <Top></Top> -->
		<div class="topbox">
			<Top></Top>
		</div>
		<!--内容-->
		<div class="bigbox">
			<!--    模块-->
			<div class="modularBox ">
				<router-view  />
      </div>
			<div class="bottombox">

				<Bottom></Bottom>
			</div>
		</div>
		
	</div>
</template>
<script>
	// 顶部
	import Top from '../components/top/index'
	// 底部
	import Bottom from '../components/bottom/index.vue'
	export default {
		data() {
			return {}
		},
		components: {
			Top,Bottom
		},
		mounted() {},
		methods: {}
	}
</script>
<style scoped lang="less">
	.bodybox{
	}
	.topbox{
	}
	/*    内容*/
	.bigbox {
		
	}

</style>
